import { Box, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { BIZY_KIT_I18N_NAMESPACE } from './i18n';
import type { BizyNodeProps } from './nodes/node-props';

/**
 * Fallback renderer for any node whose `type` this client doesn't know about,
 * or whose renderer threw (via the error boundary). Shows a minimal
 * placeholder instead of crashing the message — so an older client can still
 * participate in a conversation that used a node type shipped after it.
 */
export function UnsupportedNode({ node }: Partial<BizyNodeProps>) {
	const { t } = useTranslation(BIZY_KIT_I18N_NAMESPACE);
	const type = node?.type ?? 'unknown';
	return (
		<Box my={2} px={3} py={2} bg="bg.subtle" border="1px dashed" borderColor="border.default" borderRadius="md">
			<Text fontSize="xs" color="text.softer">
				{t('uiBlocks.unknown', { type })}
			</Text>
		</Box>
	);
}
